import type { ReactNode } from 'react'

interface StarterPageProps {
  eyebrow?: string
  title: string
  description: string
  children?: ReactNode
}

export function StarterPage({
  eyebrow = 'Elecciones Seccionales 2027',
  title,
  description,
  children,
}: StarterPageProps) {
  return (
    <section className="starter-shell">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p>{description}</p>
      {children}
    </section>
  )
}
